import { render } from "./TotalSales.vue?vue&type=template&id=1e50c8f8&scoped=true"
import script from "./TotalSales.vue?vue&type=script&lang=js"
export * from "./TotalSales.vue?vue&type=script&lang=js"

import "./TotalSales.vue?vue&type=style&index=0&id=1e50c8f8&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e50c8f8"]])

export default __exports__